/* HomeRouter — GC64 · MP-12 · Feb 2026
 * =====================================
 * Role-aware /home surface.
 *
 * • adi / pdi / admin → InstructorToday (canonical WORKING calendar
 *   operations station — the live diary used to run the day).
 * • Every other role → the existing Home component (calm learner
 *   surface, unchanged).
 *
 * This is a THIN switch — it does NOT create a second calendar
 * implementation. `Today` and `Home` are the pre-existing
 * canonical surfaces registered in App.js. This module simply
 * decides which one to render on the `/home` route.
 *
 * Do NOT embed CalendarPlanner here. CalendarPlanner is the
 * management/adjustment/month-view surface at `/calendar-planner`
 * — a distinct concern.
 */
import Home from "./Home";
import Today from "./Today";
import { useAuth } from "../context/AuthContext";
import { resolveEffectiveRole } from "../utils/roleResolver";

const INSTRUCTOR_EFFECTIVE_ROLES = new Set(["adi", "pdi", "admin"]);

export default function HomeRouter() {
  const { user } = useAuth();
  const effectiveRole = String(resolveEffectiveRole(user) || "").toLowerCase();
  if (INSTRUCTOR_EFFECTIVE_ROLES.has(effectiveRole)) {
    // InstructorToday operations station — pulls from
    // useLiveTodayData / /api/instructor/today.
    return <Today />;
  }
  return <Home />;
}
